import { useState, useEffect } from "react";
import { Stack, Dropdown, IDropdownOption } from "@fluentui/react";
import { PowerplantInfo } from "../../api";
import styles from "./FilterPowerplantSettings.module.css";

interface Props {
    filterPowerplantInputs: string;
    updateFilterPowerplant: (input: string) => void;
    powerplants: Record<string, PowerplantInfo>;
    label: string;
}

export const FilterPowerplantSettings = ({ updateFilterPowerplant, filterPowerplantInputs, powerplants, label }: Props) => {
    const [selectedPlant, setSelectedPlant] = useState<string | undefined>(undefined);

    // Keep local state in sync if parent updates it
    useEffect(() => {
        if (filterPowerplantInputs) {
            setSelectedPlant(filterPowerplantInputs);
        } else {
            setSelectedPlant(undefined);
        }
    }, [filterPowerplantInputs]);

    const lastPowerplantIds = new Set(["lorin", "demo"]);

    const options: IDropdownOption[] = Object.entries(powerplants)
        .sort(([a], [b]) => {
            const aIsLast = lastPowerplantIds.has(a);
            const bIsLast = lastPowerplantIds.has(b);
            if (aIsLast && !bIsLast) return 1;
            if (!aIsLast && bIsLast) return -1;
            return 0;
        })
        .map(([id, info]) => ({
            key: id,
            text: info.name || id
        }));

    return (
        <Stack className={styles.container} tokens={{ childrenGap: 10 }}>
            <Dropdown
                selectedKey={selectedPlant}
                label={label}
                placeholder="Select a powerplant..."
                options={options}
                required
                onChange={(_e, option) => {
                    if (option && typeof option.key === "string") {
                        setSelectedPlant(option.key);
                        updateFilterPowerplant(option.key);
                    }
                }}
            />
        </Stack>
    );
};
